module.exports = __webpack_public_path__ + "img/atyrau.a3ec0c2d.jpg";